module.exports = __webpack_public_path__ + "static/media/mazda.6b74dc14.svg";